import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { Header } from '../common/Header';
import { Footer } from '../common/Footer/Footer';
import { useScrollToTop } from '../../hooks/useScrollToTop';
import {
  LayoutContainer,
  ContentContainer,
  Main,
  FooterWrapper,
} from './MainLayout.styled';

// Reserves space while a lazily-loaded route chunk resolves (header/footer
// stay rendered above/below).
const RouteFallback = styled.div`
  min-height: 60vh;
`;

export const MainLayout: React.FC = () => {
  // Use the scroll to top hook
  useScrollToTop();

  return (
    <LayoutContainer>
      <Header />
      <Main>
        <ContentContainer>
          <Suspense fallback={<RouteFallback />}>
            <Outlet />
          </Suspense>
        </ContentContainer>
      </Main>
      <FooterWrapper>
        <Footer />
      </FooterWrapper>
    </LayoutContainer>
  );
};